import { useProps } from "@/lib/page-rendering"

export type NewProps = {
  listing_profile_name: string
  relief_listing_options: Array<SelectOption<string> & { disabled: boolean }>
  relief_invitable_token: string
}

export const useNewProps = () => useProps<NewProps>()

export type ShowProps = {
  listing_profile_name: string
}

export const useShowProps = () => useProps<ShowProps>()
